import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { ScoreBadge, SourceTag, formatDate, daysUntil, formatGBP } from "../lib/format";

export default function Tracked() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/tracked").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);
  return (
    <div data-testid="tracked-page">
      <div className="mb-6">
        <div className="label-meta">Pipeline</div>
        <div className="display">Tracked opportunities</div>
        <p className="text-[13px] mt-1" style={{ color: "var(--parapet-text-secondary)" }}>
          Each tracked opportunity includes an auto-generated bid-readiness checklist.
        </p>
      </div>
      {loading ? <span className="spinner" /> : items.length === 0 ? (
        <div className="empty-state"><h3>Nothing tracked yet</h3><p>Open an opportunity and click "Track" to add it here.</p></div>
      ) : (
        <div className="p-card" style={{ padding: 0 }}>
          <table className="p-table">
            <thead><tr><th style={{ width: 60 }}>Fit</th><th>Title</th><th>Buyer</th><th style={{ width: 130 }}>Deadline</th><th style={{ width: 160 }}>Checklist</th></tr></thead>
            <tbody>
            {items.map((t) => (
              <tr key={t.notice.id} data-testid={`tracked-row-${t.notice.id}`}
                  onClick={() => navigate(`/app/opportunities/${t.notice.id}`)} style={{ cursor: "pointer" }}>
                <td><ScoreBadge score={t.fit?.score} band={t.fit?.band} insufficient={t.fit?.insufficient_data} /></td>
                <td>
                  <Link to={`/app/opportunities/${t.notice.id}`} className="font-medium hover:underline"
                        onClick={(e) => e.stopPropagation()}>{t.notice.title}</Link>
                  <div className="mt-1" onClick={(e) => e.stopPropagation()}><SourceTag source={t.notice.source} url={t.notice.source_url} /></div>
                </td>
                <td className="text-[13px]">{t.notice.buyer_name || "—"}</td>
                <td>
                  {t.notice.deadline ? (
                    <div>
                      <div className="text-[12px]">{formatDate(t.notice.deadline)}</div>
                      <div className="text-[11px]" style={{ color: "var(--parapet-text-secondary)" }}>{daysUntil(t.notice.deadline)}d</div>
                    </div>
                  ) : <span className="text-[12px]" style={{ color: "var(--parapet-text-secondary)" }}>Not published</span>}
                </td>
                <td>
                  <div className="value-mono text-[13px]">{t.checklist_completed} / {t.checklist_total}</div>
                  <div style={{ height: 4, background: "var(--parapet-surface)", borderRadius: 2, marginTop: 4 }}>
                    <div style={{ height: 4, background: "#111", borderRadius: 2,
                                  width: `${t.checklist_total ? (t.checklist_completed * 100) / t.checklist_total : 0}%` }} />
                  </div>
                </td>
              </tr>
            ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
